module.exports = __webpack_public_path__ + "img/24_28.60314a91.png";